import { useState } from "react";
import Editor from "react-simple-wysiwyg";
import { FieldError, useForm, UseFormRegister } from "react-hook-form";

interface MyInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register: UseFormRegister<any>; // Allowing dynamic forms
  error?: FieldError;
  validationRules?: object; // Pass validation rules dynamically
}

export default function MyEditor({
  name,
  register,
  error,
  validationRules,
  ...rest
}: MyInputProps) {
  const [html, setHtml] = useState("my <b>HTML</b>");

  function onChange(e: any) {
    setHtml(e.target.value);
  }

  return <Editor value={html} onChange={onChange} />;
}
